import tailwindConfig from "../../tailwind.config"

export const breakpoints = Object.entries(tailwindConfig.theme.screens)
    .reduce((acc,[k,v]) => {
        if (!k.startsWith('v-') && !k.startsWith('o-')) acc.push([k, +v.replace('px', '')])
        return acc
    }, [])
    .sort((a,b) => b[1] - a[0])

export const breakpointMap = new Map(breakpoints)

export const getBreakpoint = () => {
    if (window.innerWidth < breakpoints[0][1]) {
        return 'base'
    }
    if (window.innerWidth > breakpoints[breakpoints.length-1][1]) {
        return breakpoints[breakpoints.length-1][0]
    }
    const entry = breakpoints.find(e => e[1] >= window.innerWidth)
    return entry ? entry[0] : 'base'
}
